export const appCoupon = {
    create: function(){
        var that = this;
        that.bindEvents();
    },
    bindEvents: function(){
        var that = this;
        // changing label position on focus/blur
        $(document).on('focus', '.js-coupon-field', function(){
            $('.js-coupon-wrapper').attr('data-state', 'label');
        });
        $(document).on('blur', '.js-coupon-field', function(){
            var hasValue = $('.js-coupon-field').val().length > 0 ? true : false;
            if(!hasValue){
                $('.js-coupon-wrapper').attr('data-state', 'placeholder');
            }
        });
        $(document).on('click', '.js-coupon-button', function(e){
            e.preventDefault();
            var cCode = $('.js-coupon-field').val();
            that.checkCode(cCode);
        });
    },
    checkCode: function(cCode){
        var that = this;
        // Not sure how this is going to be handled yet
        console.log('coupon code: ', cCode);
    }
};
